import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { useDispatch } from 'react-redux';
import { loginUser } from '../features/user/userSlice';
import { FaArrowLeft } from "react-icons/fa";

const loginSchema = yup.object({
  email: yup.string().email('Enter a valid email').required('Email is required'),
  password: yup.string().required('Password is required'),
});

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState('');

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: loginSchema,
    onSubmit: async (values, { resetForm }) => {
      setLoading(true);
      setApiError("");

      const resultAction = await dispatch(loginUser(values));
      setLoading(false);

      if (loginUser.fulfilled.match(resultAction)) {
        const { user } = resultAction.payload;
        resetForm();

        if (user?.role === 'deliveryboy') {
          window.location.href = '/deliveryboy';
        } else {
          const redirectTo = localStorage.getItem("checkoutRedirect") || "/";
          localStorage.removeItem("checkoutRedirect");
          navigate(redirectTo);
        }
      } else {
        setApiError(resultAction.payload?.message || "Invalid email or password");
      }
    },
  });

  return (
    <div className="py-5 d-flex justify-content-center align-items-center" style={{ background: "#f3f7ef", minHeight: "100vh" }}>
      <div className="card shadow-lg p-4 p-md-5 rounded-4 w-100 position-relative"
           style={{ maxWidth: "420px", border: "1px solid #e5f3db" }}>

        {/* Cute Grocery Back Button */}
        <button
          onClick={() => navigate(-1)}
          className="btn btn-light rounded-pill shadow-sm position-absolute top-0 start-0 m-3 d-flex align-items-center gap-2 px-3 py-2"
        >
          <FaArrowLeft size={14} />
          Back
        </button>

        <h3 className="text-center fw-bold mt-4 mb-4" style={{ color: "#3b7d2f" }}>
          Welcome Back 👋
        </h3>

        <form onSubmit={formik.handleSubmit} className="d-flex flex-column gap-3">

          {/* Email */}
          <div className="form-floating">
            <input
              className="form-control rounded-3"
              type="email"
              name="email"
              placeholder="Email"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.email}
            />
            <label>Email</label>
            {formik.touched.email && formik.errors.email && (
              <div className="text-danger small mt-1">{formik.errors.email}</div>
            )}
          </div>

          {/* Password */}
          <div className="form-floating">
            <input
              className="form-control rounded-3"
              type="password"
              name="password"
              placeholder="Password"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.password}
            />
            <label>Password</label>
            {formik.touched.password && formik.errors.password && (
              <div className="text-danger small mt-1">{formik.errors.password}</div>
            )}
          </div>

          {/* API Errors */}
          {apiError && (
            <div className="text-danger small text-center">{apiError}</div>
          )}

          <div className="d-flex justify-content-end">
            <Link to="/forget-password" className="small text-success fw-semibold">
              Forgot Password?
            </Link>
          </div>

          {/* Login Button */}
          <button 
            type="submit" 
            className="btn btn-success w-100 py-2 rounded-3 fw-semibold"
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2"></span>
                Logging in...
              </>
            ) : (
              "Login"
            )}
          </button>

          <div className="text-center mt-2">
            <span className="small">Don't have an account? </span>
            <Link to="/signup" className="small fw-semibold text-success text-decoration-none">
              Create Account
            </Link>
          </div>

        </form>
      </div>
    </div>
  );
};

export default Login;
